import { fetchTowerUnitsStart, fetchTowerUnitsSuccess, fetchTowerUnitsError } from '../../../../../redux/features/towerUnits';
import { fetchResponseAdapter } from '../../../../../adapters/fetchAdapter';
import { useDispatch, useSelector } from 'react-redux';
import { getAuthToken } from '../../../../../helpers/authHelper';
import { useCallback } from 'react';
import { getTowerUnits } from '../../../services/devsServices';
import useCallApiAndLoad from '../../../../../hooks/useCallApiAndLoad';

export const useTowerUnits = () => {
  const { callEndpoint } = useCallApiAndLoad();
  const dispatch = useDispatch();
  const user = useSelector((store: any) => store.auth);
  const token = getAuthToken(user);
  const towerUnitsState = useSelector((store: any) => store.towerUnits);
  const towerUnitsLoading = towerUnitsState.loading;
  const towerUnitsError = towerUnitsState.error;
  const towerUnitsData = towerUnitsState.data;

  const fetchTowerUnits = useCallback(async (id: string, filters: Record<string, string | number>, load?: boolean) => {
    if (towerUnitsLoading) return; // Si está cargando, no consultar de nuevo

    load && dispatch(fetchTowerUnitsStart());
    try {
      let cleanFilters: Record<string, string | number> | undefined = undefined;
      if (filters) {
        cleanFilters = Object.fromEntries(
          Object.entries(filters)
            .filter(([key, value]) => key !== "page" && key !== "take" && value !== undefined && value !== null && value !== "" && value !== "0")
        );
      }

      const { status, data } = await callEndpoint(getTowerUnits(token, id, cleanFilters));
      if (status === 200) {
        const response = fetchResponseAdapter(data);
        dispatch(fetchTowerUnitsSuccess(response.data));
      } else {
        dispatch(fetchTowerUnitsError('Error al obtener tower units'));
      }
    } catch (error: any) {
      console.log({ error })
      dispatch(fetchTowerUnitsError(error?.message || 'Error desconocido'));
    }
  }, [dispatch, token, towerUnitsLoading]);

  return { fetchTowerUnits, towerUnitsLoading, towerUnitsError, towerUnitsData };
};
